
<mat-stepper [orientation]="stepperMode" headerPosition="bottom" #stepper>
    <mat-step state="history_toggle_off">
        <ng-template matStepLabel>Pending</ng-template>
    </mat-step>
    <mat-step  state="history_toggle_off">
              <ng-template matStepLabel>Shipped</ng-template>
       
      
    </mat-step>
    <mat-step state="history_toggle_off">
      <ng-template matStepLabel>Delivered</ng-template>
    </mat-step>
  </mat-stepper>